import dayjs from 'dayjs';
import { Message, MessageBox } from 'element-ui';
import { SIGN_STATUS, SIGN_TYPE, APPROVE_STATUS, YES_OR_NO } from './component/utils/constant.js';
import { validateSearchTime } from './component/utils/index.js';
import { getAttachmentDetail } from '@/modules/transport/otp/api/performanceReceiptSign.js';
import _ from 'lodash';
import { searchFieldSeperated } from './search.js';
/**
 * @description 格式化查询参数
 * @param {Object} data 查询参数
 */
export const formatSearchData = data => {
    const params = _.cloneDeep(data);
    params.beginDate = params.searchTime ? dayjs(params.searchTime[0]).format('YYYY-MM-DD HH:mm:ss') : '';
    params.endDate = params.searchTime ? dayjs(params.searchTime[1]).format('YYYY-MM-DD HH:mm:ss') : '';
    params.requestSignDateStart = params.requestSignTime ? dayjs(params.requestSignTime[0]).format('YYYY-MM-DD HH:mm:ss') : '';
    params.requestSignDateEnd = params.requestSignTime ? dayjs(params.requestSignTime[1]).format('YYYY-MM-DD HH:mm:ss') : '';
    params.signTimeStart = params.receiptSignTime ? dayjs(params.receiptSignTime[0]).format('YYYY-MM-DD HH:mm:ss') : '';
    params.signTimeEnd = params.receiptSignTime ? dayjs(params.receiptSignTime[1]).format('YYYY-MM-DD HH:mm:ss') : '';
    params.arrivalTimeStart = params.arrivalTime ? dayjs(params.arrivalTime[0]).format('YYYY-MM-DD HH:mm:ss') : '';
    params.arrivalTimeEnd = params.arrivalTime ? dayjs(params.arrivalTime[1]).format('YYYY-MM-DD HH:mm:ss') : '';
    params.electronicUploadStartTime = params.electronicUploadTime ? dayjs(params.electronicUploadTime[0]).format('YYYY-MM-DD HH:mm:ss') : '';
    params.electronicUploadEndTime = params.electronicUploadTime ? dayjs(params.electronicUploadTime[1]).format('YYYY-MM-DD HH:mm:ss') : '';
    params.requestFileDateStart = params.requestFileDate ? dayjs(params.requestFileDate[0]).format('YYYY-MM-DD HH:mm:ss') : '';
    params.requestFileDateEnd = params.requestFileDate ? dayjs(params.requestFileDate[1]).format('YYYY-MM-DD HH:mm:ss') : '';
    params.transferTimeStart = params.transferTime ? dayjs(params.transferTime[0]).format('YYYY-MM-DD HH:mm:ss') : '';
    params.transferTimeEnd = params.transferTime ? dayjs(params.transferTime[1]).format('YYYY-MM-DD HH:mm:ss') : '';
    params.requestReceiptTransferTimeStart = params.requestReceiptTransferTime ? dayjs(params.requestReceiptTransferTime[0]).format('YYYY-MM-DD HH:mm:ss') : '';
    params.requestReceiptTransferTimeEnd = params.requestReceiptTransferTime ? dayjs(params.requestReceiptTransferTime[1]).format('YYYY-MM-DD HH:mm:ss') : '';
    const dispatchNo = params.dispatchNo || '';
    params.dispatchNoList = searchFieldSeperated(dispatchNo);
    params[params.batchQueryKey] = processQueryParams(params.batchQueryKey, params.batchQueryValue);
    if (params.whCode) {
        params.whCodeList = params.whCode.split(',').filter(Boolean);
        params.whNameList = params.whName.split(',').filter(Boolean);
    }
    // if (params.carrierCode) {
    //     params.carrierCodeList = params.carrierCode.split(',').filter(Boolean);
    //     params.carrierNameList = params.carrierName.split(',').filter(Boolean);
    // }
    if (params.siteCode) {
        params.siteCodeList = params.siteCode.split(',');
        params.siteNameList = params.siteName.split(',');
    }
    if (params.customerCode) {
        params.customerCodeList = params.customerCode.split(',');
        params.customerNameList = params.customerName.split(',');
    }
    delete params.dispatchNo;
    delete params.batchQueryKey;
    delete params.batchQueryValue;
    delete params.startTime;
    delete params.endTime;
    delete params.searchTime;
    delete params.arrivalTime;
    delete params.requestSignTime;
    delete params.receiptSignTime;
    delete params.electronicUploadTime;
    delete params.transferTime;
    delete params.requestReceiptTransferTime;
    delete params.requestFileDate;
    delete params.whCode;
    delete params.whName;
    delete params.siteCode;
    delete params.siteName;
    delete params.customerCode;
    delete params.customerName;
    return params;
};

const processQueryParams = (key, value) => {
    const batchQueryKeyArr = ['customerOrderNoList', 'contractNoList', 'orderNoList', 'waybillNoList', 'jdvcList', 'taskNoList', 'collectNoList', 'assembleNoList'];
    if (batchQueryKeyArr.includes(key)) {
        return searchFieldSeperated(value || '');
    } else {
        return value || '';
    }
};

export const setAllPropertyValuesToNull = obj => {
    for (const key in obj) {
        if (obj.hasOwnProperty(key) && key !== 'batchQueryKey') {
            obj[key] = null;
        }
    }
};

/**
 * @description 过滤对象中的空值（空字符串、空对象、空数组、null、undefined）
 * @param {Object} obj 待处理对象
 * @returns {Object} 处理后的真值对象
 */
export const removeFalsyValues = obj => {
    return Object.fromEntries(
        Object.entries(obj).filter(([_, value]) =>
            (!(value === '' || value === null || value === undefined)) &&
            (!(Array.isArray(value) && value.length === 0)) &&
            (!(typeof value === 'object' && Object.keys(value).length === 0))
        )
    );
};

/**
 * @description 校验查询参数
 * @param {Object} data 查询参数
 * @param {Number} maxSearchDay 最大查询区间
 * 校验规则：
 * - 客户订单号 和 创建时间 不可同时为空
 * - 按时间查询或导出时，查询或导出时间跨度不可超过两个月
 */
export const validateSearchData = (data, maxSearchDay = 31, maxNum = 100) => {
    const oddNumbersField = ['customerOrderNoList', 'contractNoList', 'orderNoList', 'waybillNoList', 'jdvcList', 'taskNoList', 'dispatchNoList', 'collectNoList', 'assembleNoList'];
    const batchSearchField = ['customerOrderNoList', 'contractNoList', 'orderNoList', 'waybillNoList', 'jdvcList', 'taskNoList', 'dispatchNoList', 'collectNoList', 'assembleNoList'];
    if (requiredVerification(data, oddNumbersField) && !data.beginDate && !data.arrivalTimeStart && !data.signTimeStart && !data.requestFileDateStart) {
        Message.warning('单号、创建时间、抵达时间、签收时间、要求回单时间 不可同时为空');
        return false;
    }
    if (maxLengthVerification(data, batchSearchField, maxNum)) {
        Message.warning(`按照单号查询，每次最多支持查询${maxNum}单`);
        return false;
    };
    return validateSearchTime(data, 'beginDate', 'endDate', maxSearchDay) &&
        validateSearchTime(data, 'arrivalTimeStart', 'arrivalTimeEnd', maxSearchDay) &&
        validateSearchTime(data, 'signTimeStart', 'signTimeEnd', maxSearchDay) &&
        validateSearchTime(data, 'requestFileDateStart', 'requestFileDateEnd', maxSearchDay) &&
        validateSearchTime(data, 'transferTimeStart', 'transferTimeEnd', maxSearchDay) &&
        validateSearchTime(data, 'requestReceiptTransferTimeStart', 'requestReceiptTransferTimeEnd', maxSearchDay);
};

// 处理导出参数
export const dealWithExportParams = searchParams => {
    const { beginDate, endDate } = searchParams;
    for (const k in searchParams) {
        if (searchParams[k] === '') {
            delete searchParams[k];
        }
    }
    return {
        ...searchParams,
        beginDate2: beginDate,
        endDate2: endDate
    };
};

/**
 * @description 处理订单类型字典映射
 * @param {Obejct} ORDER_TYPE 订单类型字典数据
 * @param {Object} v 当前表格行数据
 */
export const mapOrderTypeDictField = (ORDER_TYPE, v) => {
    const IS_CAI_NIAO = v.sourceSystem === 'CAINIAO'; // 来源系统是菜鸟(SOURCE_SYSTEM)
    const IS_YS = v.orderType === 'YS'; // 订单类型是纯运输订单(ORDER_TYPE)
    const SERVICE_TYPE_8 = +v.serviceType === 8; // 服务类型是8(SERVICE_TYPE_OTP), 8暂不知道是啥类型，业务要求等于8
    return IS_CAI_NIAO && IS_YS && SERVICE_TYPE_8 ? '逆向运输' : v.orderType ? ORDER_TYPE[v.orderType] : '';
};

const maxLengthVerification = (data, fieldList, maxNum = 100) => {
    return fieldList.some(v => data[v] && data[v].length > maxNum);
};

const requiredVerification = (data, fieldList) => {
    return fieldList.every(v => !(data[v] && data[v].length));
};

/**
 * @description 逾期类型与二级逾期原因所使用的字典关系绑定
 */
export const CURRENT_OVERDUE_TYPE = {
    0: 'OVERDUE_ARRIVE_2', // 到货逾期二级原因字典
    1: 'OVERDUE_RECEIPT_2', // 签收逾期二级原因字典
    2: 'PUPPLIER_TURN_OVER', // 供方移交二级逾期原因字典
    3: 'ACCOUNT_TURN_OVER', // 结算移交二级逾期原因字典
    4: 'ACCOUNT_TURN_OVER_SURE' // 结算移交确认二级逾期原因字典
};

/**
 * @description 将数据字典数据映射为{label: 'xx', value: 'xx'}形式
 * @param {Object} dictData 字典数据
 * @returns {Array} [{ label: 'xx', value: 'xx' }, { label: 'xx', value: 'xx' }]
 */
export const formatDictDataToLabelValue = dictData => {
    return Object.entries(dictData).map(v => ({ label: v[1], value: v[0] }));
};

/**
 * @param {String} n 当前选中的一级逾期原因值
 * @param {Object} dictData 当前选中的逾期类型所对应的二级逾期原因字典数据
 * @returns {Array} array 返回值，是一个数组 [{label: 'xx', value: 'xx'}, {label: 'xx', value: 'xx'}]
 */
export const filterDictDataByVal = (n, dictData) => {
    const reg = new RegExp(`^(${n})_\\d+$`, 'i'); // 匹配出n_xx: xx，n是所选的一级逾期原因值
    const newDictData = {};
    Object.keys(dictData).forEach(k => {
        if (k.match(reg)) {
            newDictData[k] = dictData[k];
        }
    });
    return formatDictDataToLabelValue(newDictData);
};

/**
 * @description 将数量字段设置默认值，若后端返回null，设置为0
 * @param {Array} list 列表数据
 */
export const setFieldDefaultValueToZero = list => {
    list.forEach(v => {
        v.quantity = v.quantity || 0; // 总数量
        v.realDeliverCount = v.realDeliverCount || 0; // 实发数量
        v.mildewPolluteCount = v.mildewPolluteCount || 0; // 霉变污染数量
        v.packageDamagedCount = v.packageDamagedCount || 0; // 包装破损数量
        v.stockoutCount = v.stockoutCount || 0; // 货物短少数量
        v.rejectQty = v.rejectQty || 0; // 拒收数量
        v.realReceive = v.realReceive || 0; // 用户实收数量
        v.receiverRealReceiveCount = v.receiverRealReceiveCount || 0; // 用户签收数量
        v.receiverPackageDamagedCount = v.receiverPackageDamagedCount || 0; // 用户签收破损数量
        v.receiverMildewPolluteCount = v.receiverMildewPolluteCount || 0; // 用户签收污染数量
        v.receiverStockoutCount = v.receiverStockoutCount || 0; // 用户签收短少数量
        v.receiverRejectQty = v.receiverRejectQty || 0; // 用户签收拒收数量
    });
    return list;
};

/**
 * @description 格式化批量签收请求参数
 * @param {Array} list 选中的表格数据
 */
export const formatBatchSignRequestParams = list => {
    return list.map(v => {
        return {
            signContact: v.signContact || v.currentUserName, // 签收人
            batchSignFlag: '0', // 签收操作 0:批量 1: 非批量
            signType: v.signType || '3', // 签收类型
            signTime: dayjs(new Date()).format('YYYY-MM-DD HH:mm:ss'), // 签收时间。取当前时间
            receiptSignDto: {
                taskNo: v.taskNo, // 运输单号
                version: v.version || 0 // 版本 只要用来解决缓存问题
            },
            receiptDetailSignDtoList: [] // 签收明细，批量签收传空
        };
    });
};

/**
 * @description 创建时间格式处理
 * @description createTime 创建时间
 * @return data 查询数据
 */
export const formatSetSearchTime = data => {
    const searchData = _.cloneDeep(data);
    // 校验时间格式是否为 YYYY-MM-DD HH:mm:ss
    const reg = /^(\d{1,4})\-(\d{1,2})\-(\d{1,2}) (\d{1,2}):(\d{1,2}):(\d{1,2})$/;
    if (searchData.searchTime && !reg.test(searchData.searchTime[0])) {
        searchData.searchTime[0] = formatTime(searchData.searchTime[0]);
        searchData.searchTime[1] = formatTime(searchData.searchTime[1]);
    }
    if (searchData.requestSignTime && !reg.test(searchData.requestSignTime[0])) {
        searchData.requestSignTime[0] = formatTime(searchData.requestSignTime[0]);
        searchData.requestSignTime[1] = formatTime(searchData.requestSignTime[1]);
    }
    delete searchData.batchQueryKey;
    delete searchData.batchQueryValue;
    return searchData;
};

/// 将日期格式化为 2021-12-02 18:08:23 这样的格式
function formatTime (dateString) {
    return dayjs(dateString).format('YYYY-MM-DD HH:mm:ss');
}

/**
 * @description 弹窗配置信息
 * @param {String} dialogTitle 弹窗标题
 * @param {*} operateType 操作标识 01: 网批驳回 02: 签收确认 03: 拒收
 * @param {String} width 弹窗宽度
 * @param {Number} isChargeEdit 卸货上楼标识是否可编辑, 默认为0即不可编辑，1为可编辑
 */
export const dialogConfig = (dialogTitle, operateType, width = '1200px', isChargeEdit = 0) => {
    return {
        dialogTitle,
        operateType,
        width,
        isChargeEdit
    };
};

/**
 * @description 处理列表按钮隐藏显示
 * @param {Object} data 当前操作表格行数据
 */
export const dealWithBtnShow = data => {
    const { signStatus, businessMode, sourceSystem, distributionFlag, distributionNum, projectClassify } = data;
    const hiddenEvent = [];
    // 反查按钮逻辑
    if (data.recheckAble === '0') {
        hiddenEvent.push('recheck');
    }

    // 签收按钮逻辑

    // 签收状态不为未签收(60)。 字典：SIGN_STATUS
    const isSignPending = data.signStatus !== SIGN_STATUS.SIGN_PENDING;

    // 存在快递单号
    const existExpressNo = data.expressNo;

    // 经过网点的单据隐藏签收、拒收按钮，经网点的判断：配送方式为宅配(DOT)或网点配送(NET)。 字典：DELIVERY_TYPE
    const networkOrder = data.deliveryType === 'DOT' || data.deliveryType === 'NET';

    // 非最后一段运输隐藏签收、拒收按钮，非末段分拨的判断：是否最后一次分拨为否 (Y：是，N：否) 字典：DISTRIBUTION_LAST_FLAG
    const noDistributionLast = data.distributionLastFlag === 'N';

    if (isSignPending || existExpressNo || networkOrder || noDistributionLast) {
        hiddenEvent.push('receipt');
    }

    // 拒收按钮逻辑

    // 业务模式为B2B，且 系统来源不为 菜鸟、百度，隐藏拒收按钮。字典：BUSINESS_MODE、SOURCE_SYSTEM
    const sourceSystemFlag = (businessMode === 'B2B' && sourceSystem !== 'CAINIAO' && sourceSystem !== 'BAIDU-WBKH');

    // 业务模式为B2C，且 为分拨单，分拨段号为1，隐藏拒收按钮。字典：DISTRIBUTION_FLAG
    const distributionNumFlag = (businessMode === 'B2C' && distributionFlag === 'Y' && +distributionNum === 1);

    // 业务模式为B2C，且 系统来源为 CIMS， 项目分类为 网批，隐藏拒收按钮。字典：PROJECT_CLASSIFY
    const projectClassifyFlag = (sourceSystem === 'CIMS' && businessMode === 'B2C' && projectClassify === 'WP');

    // 签收状态为 网批签收中、完成、已拒收，隐藏拒收按钮。字典：SIGN_STATUS
    const signStatusList = ['70', '100', '200'].includes(signStatus);

    if (sourceSystemFlag || distributionNumFlag || projectClassifyFlag || signStatusList || networkOrder || noDistributionLast) {
        hiddenEvent.push('reject');
    }

    // 来源为苏宁的订单，签收中心状态等于待签收，并且最后一次分拨，展示拒收按钮
    if (data.kaType === 'OFC_SUNING' && signStatus === '60' && data.distributionLastFlag === 'Y') {
        const index = hiddenEvent.indexOf('reject');
        if (index !== -1) {
            hiddenEvent.splice(index, 1);
        }
    }

    // 没有签收逾期登记时，不显示逾期明细查询按钮
    if (data.receiptOverdue === YES_OR_NO.NO) {
        hiddenEvent.push('overdueDetailQuery');
    }

    // 重推按钮显示控制

    // 订单来源系统为美云销(OFC)
    const isMeiYunXiao = data.sourceSystem === 'OFC';

    // 签收状态为已签收(100)、拒收(200)。 字典：SIGN_STATUS
    const isReceipted = data.signStatus === '100' || data.signStatus === '200';

    // 是否最后一次分拨(Y：是，N：否) 字典：DISTRIBUTION_LAST_FLAG
    const isDistributionLastFlag = data.distributionLastFlag === 'Y';

    // 订单类型为销售出库。 字典：ORDER_TYPE
    const orderTypeIsPO = data.orderType === 'PO' || data.orderType === 'DO';

    // 运输方式为宅配(DOT)或网点配送(NET)不予展示。 字典：DELIVERY_TYPE
    const deliveryType = data.deliveryType === 'DOT' || data.deliveryType === 'NET';

    if (!isMeiYunXiao || !isReceipted || !isDistributionLastFlag || !orderTypeIsPO || deliveryType) {
        hiddenEvent.push('rePush');
    }

    // 签收改拒收显示控制

    // 订单来源系统为菜鸟(CAINIAO)
    const isCaiNiao = data.sourceSystem === 'CAINIAO';

    // 电商分类为(01-大件电商) 字典：OMS_E_COMMERCE_CATEGORIES
    const isCommerceCategories = data.commerceCategories === '01';

    // 订单类型为(PO-销售出库)。 字典：ORDER_TYPE
    const isPO = data.orderType === 'PO';

    if (!isCaiNiao || !isReceipted || !isDistributionLastFlag || !isCommerceCategories || !isPO) {
        hiddenEvent.push('change');
    }

    // 预签收按钮显隐控制
    data.lspSignFlag === 'N' && hiddenEvent.push('preReceipt');
    data.lspSignLogFlag === 'N' && hiddenEvent.push('preReceiptLog');

    // 增值费修改显示控制：是否串点计费为是，且出入库类型： 出库单、纯运输，且已签收确认、已拒收才显示按钮
    if (+data.dmsFlag !== 1 || !['OUT', 'YS'].includes(data.inOutType) || ![100, 200].includes(+data.signStatus)) {
        hiddenEvent.push('chargeEdit');
    }
    return hiddenEvent;
};

/**
 * @description 校验异常审批是否满足操作条件
 * @param {Array} selected 选中的表格数据
 */
export const validateExceptionApprove = selected => {
    // 是否选中数据
    const isNotEmpty = selected.length > 0;

    // 审批状态是否为空或者作废
    const applyStatusIsTrue = selected.every(v => !v.applyStatus || v.applyStatus === APPROVE_STATUS.CAST);

    // 签收类型是电子签收并且配送方式是非网点配送
    const deliveryIsTrue = selected.every(v => v.deliveredVerifyFlag === SIGN_TYPE.ELECTRON_SIGN && v.deliveryType !== 'NET');

    // 签收状态为待签收
    const signStatusIsTrue = selected.every(v => v.signStatus === SIGN_STATUS.SIGN_PENDING);

    if (!isNotEmpty) {
        return Message.warning('请选择运单！');
    }

    if (!applyStatusIsTrue) {
        return Message.warning('审批状态为空或者作废时才允许审批！');
    }

    if (!deliveryIsTrue) {
        return Message.warning('只有电子签收且非网点配送的单才可以发起异常审批！');
    }

    if (!signStatusIsTrue) {
        return Message.warning('只有待签收状态才可以发起异常审批！');
    }
};

// 佐证附件上传操作类型
export const evidenceOperateType = {
    df: {
        label: '上传',
        dialogTitle: '上楼佐证上传',
        operateType: 'edit'
    },
    0: {
        label: '上传',
        dialogTitle: '上楼佐证上传',
        operateType: 'edit'
    },
    1: {
        label: '附件查看',
        dialogTitle: '查看',
        operateType: 'view'
    },
    2: {
        label: '附件查看',
        dialogTitle: '查看',
        operateType: 'view'
    },
    3: {
        label: '更新上传',
        dialogTitle: '更新',
        operateType: 'update'
    }
};

/**
 * @description 处理表格佐证附件上传按钮
 * @param {Object} ctx 当前组件上下文
 * @param {Object} row 当前表格行数据
 */
export const dealWithTableRowEvidenceBtn = (ctx, row) => {
    const key = row.evidenceStatus === null ? 'df' : row.evidenceStatus;
    const { dialogTitle, operateType } = evidenceOperateType[key];
    ctx.dialogConfig = dialogConfig(dialogTitle, operateType, '600px');
    ctx.leftUploadRightContentVisible = true;
};

/**
 * @description 获取附件详情
 * @param {Number} objId 签收列表id
 * @param {String} objType 附件详情标识 【RECEIPT_CVTE_CONFIRM：佐楼上传附件】
 */
export const handleGetAttachmentDetail = (objId, objType) => {
    return new Promise((resolve, reject) => {
        return getAttachmentDetail({
            objId, objType
        }).then(res => {
            if (res && +res.code === 0) {
                resolve(res.data || []);
            }
        });
    });
};

/**
 * @description 按钮操作 二次确认的消息提示
 * @param {String} tipsInfo 提示信息
 * @param {String} api 调用的接口
 * @param {Array/String/Object} params 接口参数
 * @param {String} successTips 操作成功的提示
 * @param {Object} that 接收函数调用者的 this
 */
export const ReConfirmTip = (tipsInfo = '此操作将永久修改该数据, 是否继续？', api, params, successTips = '操作成功', that) => {
    MessageBox.confirm(tipsInfo, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
        beforeClose: (action, instance, done) => {
            if (action === 'confirm') {
                instance.confirmButtonLoading = true;
                instance.confirmButtonText = '执行中...';
                api(params)
                    .then(res => {
                        if (res && +res.code === 0) {
                            Message.success(successTips);
                            done();
                        }
                    })
                    .catch((errMsg) => {
                        Message.error(errMsg);
                    })
                    .finally(() => {
                        instance.confirmButtonLoading = false;
                        done();
                        that.getList();
                    });
            } else {
                done();
            }
        }
    }).catch(() => { }); // 添加错误捕获
};

/**
 * @description 按钮操作 二次确认的消息提示
 * @param {String} tipsInfo 提示信息
 * @param {String} api 调用的接口
 * @param {Array/String/Object} params 接口参数
 * @param {String} successTips 操作成功的提示
 * @param {Object} that 接收函数调用者的 this
 * @param {Object} functionName 调用者的方法名
 */
export const confirmTip = (tipsInfo = '此操作将永久修改该数据, 是否继续？', api, params, successTips = '操作成功', that = null, functionName = null) => {
    MessageBox.confirm(tipsInfo, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
        beforeClose: (action, instance, done) => {
            if (action === 'confirm') {
                instance.confirmButtonLoading = true;
                instance.confirmButtonText = '执行中...';
                api(params)
                    .then(res => {
                        if (res && +res.code === 0) {
                            Message.success(successTips);
                            done();
                            that && functionName && that[functionName]();
                        }
                    })
                    .catch((errMsg) => {
                        Message.error(errMsg);
                    })
                    .finally(() => {
                        instance.confirmButtonLoading = false;
                        done();
                    });
            } else {
                done();
            }
        }
    }).catch(() => { }); // 添加错误捕获
};
